export const invitePageTestSelectors = {
  page: 'invite-page',
  searchBar: {
    input: 'invite-page-advanced-search-bar-input',
    searchButton: 'invite-page-advanced-search-bar-search-button'
  },
  submitButton: 'invite-submit-button'
};
